import React, { useEffect, useState } from 'react';
import AdminLogin from '../components/admin/AdminLogin';
import AdminDashboard from '../components/admin/AdminDashboard';

const Admin = () => {
  const [token, setToken] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('bmp_admin_token');
    const expires = localStorage.getItem('bmp_admin_expires');
    if (stored && expires && new Date(expires) > new Date()) {
      // Verify against backend in case secret rotated
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/me`, {
        headers: { Authorization: `Bearer ${stored}` },
      })
        .then((r) => {
          if (r.ok) setToken(stored);
          else {
            localStorage.removeItem('bmp_admin_token');
            localStorage.removeItem('bmp_admin_expires');
          }
        })
        .catch(() => {})
        .finally(() => setChecking(false));
    } else {
      localStorage.removeItem('bmp_admin_token');
      localStorage.removeItem('bmp_admin_expires');
      setChecking(false);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('bmp_admin_token');
    localStorage.removeItem('bmp_admin_expires');
    setToken(null);
  };

  useEffect(() => {
    document.title = 'Field Keeper · Betsy M. Pool';
  }, []);

  if (checking) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <div className="text-slate-500 font-light text-sm">Opening the Field…</div>
      </div>
    );
  }

  return token ? (
    <AdminDashboard token={token} onLogout={handleLogout} />
  ) : (
    <AdminLogin onSuccess={setToken} />
  );
};

export default Admin;
